// 顾问
<template>
  <div
    id="agency"
    class="agency-container"
  >
    <div class="agency-part-wrapper content-part-wrapper">
      <div class="agency-title-wrapper content-title-wrapper">
        <h3>{{ $t('PARTNER') }} </h3>
        <span class="title-line"></span>
      </div>
      <div class="agency-container">
        <div class="agency-item">
          <div class="agency-img-wray">
            <img
              class="ONEBOAT_Capital"
              src="../../assets/pageagency/2_2.png"
            >
          </div>
        </div>

        <div class="agency-item">
          <div class="agency-img-wray">
            <img
              class="Huobi_Capital"
              src="../../assets/pageagency/3_2.png"
            >
          </div>
        </div>


        <div class="agency-item">
          <div class="agency-img-wray">
            <img
              class="iTechClub"
              src="../../assets/pageagency/itech_3.png"
            >
          </div>
        </div>

        <div class="agency-item">
          <div class="agency-img-wray">
            <img
              class="linkvc"
              src="../../assets/pageagency/linkvc.png"
            >
          </div>
        </div>

        <div class="agency-item">
          <div class="agency-img-wray">
            <img
              class="gs_exper"
              src="../../assets/pageagency/gs.png"
            >
          </div>
        </div>
        <div class="agency-item">
          <div class="agency-img-wray">
            <img
              class="H_Capital"
              src="../../assets/pageagency/lrzb.jpg"
            >
          </div>
        </div>
        
        <div class="agency-item">
          <div class="agency-img-wray">
            <img
              class="spark_captal"
              src="../../assets/pageagency/xhzb.png"
            >
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<i18n>
{
  "en": {
    "PARTNER": "PARTNER"
  },
  "zn": {
    "PARTNER": "合作伙伴"  
  }
}
</i18n>

<script>

export default {
  created() {
    let language = this.$cookie.get("BASIC_LANUAGE");
    this.$i18n.locale = language;
  }
};
</script>

<style lang="stylus">
.agency-part-wrapper {
  margin-bottom: 70px;

  .agency-container {
    margin: 0 10%;
  }

  .agency-item {
    display: inline-block;
    width: 33.333333%;
    min-height: 65px;
    box-sizing: border-box;
    padding: 0 9%;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
    margin-bottom: 100px;

    .agency-item-content {
      display: inline-block;
      width: 100%;
      padding: 5px 10px;
      box-sizing: border-box;
    }

    img {
      vertical-align: middle;
      max-width: 180px;
    }

    img.Huobi {
      max-width: 120px;
      position: absolute;
      left: 30px;
    }

    img.iTechClub {
      max-width: 150px;
    }

    img.H_Capital {
      width: 120px;
    }

    .agency-img-wray {
      width: 100%;
      min-height: 125px;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      position: relative;
    }
  }
}

@media (max-width: 720px) {
  .agency-part-wrapper {
    margin-bottom: 40px;

    .agency-container {
      margin: 0;
    }

    .agency-item {
      width: 100%;
      padding: 0 25%;
      margin-bottom: 25px;
    }
  }
}
</style>


